<template>
  <div class="bg-zinc-50 overflow-y-scroll">
    <JsonViewer show-line-number="true" :value="jsonData" copyable sort theme="dark" :expanded="true" :expand-depth="10" />
  </div>
</template>

<script setup lang="ts">
import 'vue3-json-viewer/dist/index.css'
import { JsonViewer } from 'vue3-json-viewer'

import { reactive } from 'vue'
import type { Template } from '@/admin/types'

const props = defineProps<{
  data: Template
}>()

const jsonData = reactive(props.data)
</script>
